function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import xhrHttpCall from '../api/XhrHttpService';
import DmsStores from '../stores/dms-stores';
import AnnotationsService from '../services/annotations-service';
import AnnotationsServiceV2 from '../services/annotations-service-v2';
import ApprovalService from '../services/approval-service';
import ClientAccessService from '../services/client-access-service';
import ClientService from '../services/client-service';
import CommentsService from '../services/comments-service';
import CommunicationService from '../services/communications-service';
import CommunicationStatusService from '../services/communication-status-service';
import CommunicationSubRequestService from '../services/communications-subrequest-service';
import CompanyService from '../services/company-service';
import ContactService from '../services/contact-service';
import ContainerService from '../services/container-service';
import DocumentConstraintsService from '../services/document-constraints-service';
import DocumentService from '../services/document-service';
import EmailBodyService from '../services/email-body-service';
import ItemService from '../services/item-service';
import JobService from '../services/job-service';
import NotificationsService from '../services/notifications-service';
import RecentItemService from '../services/recent-item-service';
import RecipientsService from '../services/recipients-service';
import RegistrationService from '../services/registration-service';
import ShareService from '../services/share-service';
import StaticFilesService from '../services/static-files-service';
import TemplateService from '../services/template-service';
import ThemeService from '../services/theme-service';
import TreeService from '../services/tree-service';
import ApprovalStore from '../store-services/approval-store';
import ClientStore from '../store-services/client-store';
import CommentsStore from '../store-services/comments-store';
import ContainerStore from '../store-services/container-store';
import ItemStore from '../store-services/item-store';
import ShareStore from '../store-services/share-store';
import TemplateStore from '../store-services/template-store';
import TreeStore from '../store-services/tree-store';
function exposeVersionNumber() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.bmdms = window.bmdms || {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.bmdms.services = {
    version: '58.3.9'
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDmsGlobal() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var w = window;
  if (!w.bm) {
    w.bm = {};
  }
  if (!w.bm.services) {
    w.bm.services = {};
  }
  if (!w.bm.services.documents) {
    w.bm.services.documents = {};
  }

  // This is an agreed upon namespace for bluemoon globals
  // Our UMD publishes to this global object
  return w.bm.services.documents;
}
var DiContainer = /*#__PURE__*/function () {
  function DiContainer() {
    _classCallCheck(this, DiContainer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.instances = void 0;
    this._http = void 0;
    this.instances = new Map();
    this._http = xhrHttpCall;
    exposeVersionNumber();
  }
  return _createClass(DiContainer, [{
    key: "http",
    get: function get() {
      var _this = this;
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(config) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _this._http(config));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    set: function set(http) {
      this._http = http;
    }

    // Services
  }, {
    key: "approvalService",
    get: function get() {
      var _this2 = this;
      return this.returnOrCreate('approvalService', function () {
        return new ApprovalService(_this2.http);
      });
    }
  }, {
    key: "clientAccessService",
    get: function get() {
      var _this3 = this;
      return this.returnOrCreate('clientAccessService', function () {
        return new ClientAccessService(_this3.http);
      });
    }
  }, {
    key: "clientService",
    get: function get() {
      var _this4 = this;
      return this.returnOrCreate('clientService', function () {
        return new ClientService(_this4.http);
      });
    }
  }, {
    key: "commentsService",
    get: function get() {
      var _this5 = this;
      return this.returnOrCreate('commentsService', function () {
        return new CommentsService(_this5.http);
      });
    }
  }, {
    key: "communicationService",
    get: function get() {
      var _this6 = this;
      return this.returnOrCreate('communicationService', function () {
        return new CommunicationService(_this6.http);
      });
    }
  }, {
    key: "communicationStatusService",
    get: function get() {
      var _this7 = this;
      return this.returnOrCreate('communicationStatusService', function () {
        return new CommunicationStatusService(_this7.communicationService, _this7.communicationSubRequestService);
      });
    }
  }, {
    key: "communicationSubRequestService",
    get: function get() {
      var _this8 = this;
      return this.returnOrCreate('communicationSubRequestService', function () {
        return new CommunicationSubRequestService(_this8.http);
      });
    }
  }, {
    key: "containerService",
    get: function get() {
      var _this9 = this;
      return this.returnOrCreate('containerService', function () {
        return new ContainerService(_this9.http);
      });
    }
  }, {
    key: "companyService",
    get: function get() {
      var _this10 = this;
      return this.returnOrCreate('companyService', function () {
        return new CompanyService(_this10.http);
      });
    }
  }, {
    key: "contactService",
    get: function get() {
      var _this11 = this;
      return this.returnOrCreate('contactService', function () {
        return new ContactService(_this11.http);
      });
    }
  }, {
    key: "documentService",
    get: function get() {
      var _this12 = this;
      return this.returnOrCreate('documentService', function () {
        return new DocumentService(_this12.http);
      });
    }
  }, {
    key: "documentConstraintsService",
    get: function get() {
      var _this13 = this;
      return this.returnOrCreate('documentConstraintsService', function () {
        return new DocumentConstraintsService(_this13.http);
      });
    }
  }, {
    key: "emailBodyService",
    get: function get() {
      var _this14 = this;
      return this.returnOrCreate('emailBodyService', function () {
        return new EmailBodyService(_this14.http);
      });
    }
  }, {
    key: "itemService",
    get: function get() {
      var _this15 = this;
      return this.returnOrCreate('itemService', function () {
        return new ItemService(_this15.http);
      });
    }
  }, {
    key: "jobService",
    get: function get() {
      var _this16 = this;
      return this.returnOrCreate('jobService', function () {
        return new JobService(_this16.http);
      });
    }
  }, {
    key: "notificationsService",
    get: function get() {
      var _this17 = this;
      return this.returnOrCreate('notificationsService', function () {
        return new NotificationsService(_this17.http);
      });
    }
  }, {
    key: "recentItemService",
    get: function get() {
      var _this18 = this;
      return this.returnOrCreate('recentItemService', function () {
        return new RecentItemService(_this18.http);
      });
    }
  }, {
    key: "recipientsService",
    get: function get() {
      var _this19 = this;
      return this.returnOrCreate('recipientsService', function () {
        return new RecipientsService(_this19.contactService);
      });
    }
  }, {
    key: "registrationService",
    get: function get() {
      var _this20 = this;
      return this.returnOrCreate('registrationService', function () {
        return new RegistrationService(_this20.http);
      });
    }
  }, {
    key: "templateService",
    get: function get() {
      var _this21 = this;
      return this.returnOrCreate('templateService', function () {
        return new TemplateService(_this21.http);
      });
    }
  }, {
    key: "themeService",
    get: function get() {
      var _this22 = this;
      return this.returnOrCreate('themeService', function () {
        return new ThemeService(_this22.http);
      });
    }
  }, {
    key: "treeService",
    get: function get() {
      var _this23 = this;
      return this.returnOrCreate('treeService', function () {
        return new TreeService(_this23.http);
      });
    }
  }, {
    key: "shareService",
    get: function get() {
      var _this24 = this;
      return this.returnOrCreate('shareService', function () {
        return new ShareService(_this24.http);
      });
    }
  }, {
    key: "annotationsService",
    get: function get() {
      var _this25 = this;
      return this.returnOrCreate('annotationsService', function () {
        return new AnnotationsService(_this25.http);
      });
    }
  }, {
    key: "annotationsServiceV2",
    get: function get() {
      var _this26 = this;
      return this.returnOrCreate('annotationsServiceV2', function () {
        return new AnnotationsServiceV2(_this26.http);
      });
    }

    // Stores
  }, {
    key: "approvalStore",
    get: function get() {
      var _this27 = this;
      return this.returnOrCreate('approvalStore', function () {
        return new ApprovalStore(_this27.dmsStores, _this27.approvalService);
      });
    }
  }, {
    key: "clientStore",
    get: function get() {
      var _this28 = this;
      return this.returnOrCreate('clientStore', function () {
        return new ClientStore(_this28.dmsStores, _this28.clientService);
      });
    }
  }, {
    key: "commentsStore",
    get: function get() {
      var _this29 = this;
      return this.returnOrCreate('commentsStore', function () {
        return new CommentsStore(_this29.dmsStores, _this29.commentsService);
      });
    }
  }, {
    key: "containerStore",
    get: function get() {
      var _this30 = this;
      return this.returnOrCreate('containerStore', function () {
        return new ContainerStore(_this30.dmsStores, _this30.containerService, _this30.treeStore, _this30.itemService);
      });
    }
  }, {
    key: "itemStore",
    get: function get() {
      var _this31 = this;
      return this.returnOrCreate('itemStore', function () {
        return new ItemStore(_this31.dmsStores, _this31.containerStore, _this31.treeStore, _this31.itemService, _this31.documentService);
      });
    }
  }, {
    key: "shareStore",
    get: function get() {
      var _this32 = this;
      return this.returnOrCreate('shareStore', function () {
        return new ShareStore(_this32.dmsStores, _this32.containerService);
      });
    }
  }, {
    key: "templateStore",
    get: function get() {
      var _this33 = this;
      return this.returnOrCreate('templateStore', function () {
        return new TemplateStore(_this33.dmsStores, _this33.templateService);
      });
    }
  }, {
    key: "treeStore",
    get: function get() {
      var _this34 = this;
      return this.returnOrCreate('treeStore', function () {
        return new TreeStore(_this34.dmsStores, _this34.treeService, _this34.containerService, _this34.clientService);
      });
    }
  }, {
    key: "staticFilesService",
    get: function get() {
      var _this35 = this;
      return this.returnOrCreate('staticFilesService', function () {
        return new StaticFilesService(_this35.http);
      });
    }

    // DB Stores
  }, {
    key: "dmsStores",
    get: function get() {
      return this.returnOrCreate('dmsStores', function () {
        return new DmsStores();
      });
    }
  }, {
    key: "returnOrCreate",
    value: function returnOrCreate(key, instantiator) {
      if (!this.instances.has(key)) {
        this.instances.set(key, instantiator());
      }
      return this.instances.get(key);
    }
  }], [{
    key: "instance",
    get: function get() {
      // The only way to ensure singularity is working on the global scope.
      var dms = getDmsGlobal();
      if (!dms._diContainerInstance) {
        dms._diContainerInstance = new DiContainer();
      }
      return dms._diContainerInstance;
    }
  }]);
}();
export { DiContainer as default };
